module.exports = __webpack_public_path__ + "img/icon_dean_home_card_measure_1.45ea67bf.png";